import React from 'react';
import { Router } from '@reach/router';
import Marketing from '../../marketing';

function App() {
  return (
    <Router primary={false} basepath={process.env.PUBLIC_URL || '/'}>
      <Marketing path="/" page="home" />
      <Marketing path="/services/education-staffing" page="education" />
      <Marketing path="/services/afterschool-programming" page="afterschool" />
      <Marketing path="/resources" page="resources" />
      <Marketing path="/worker-faq" page="worker-faq" />
      <Marketing path="/worker-support" page="worker-faq" />
      <Marketing path="/category/resources/whitepapers" page="resources" />
      <Marketing path="/category/resources/casey-studies" page="resources" />
      <Marketing path="/category/resources/blog" page="resources" />
      <Marketing path="/contact-us" page="contact" />
      <Marketing path="/labor-law-posters" page="posters" />
      <Marketing path="/lessons-after-the-bell" page="lessons" />
      <Marketing path="/case-study-14th-largest-school-district-overcomes-staffing-challenges-in-their-child-nutrition-program" page="case-study" />
      <Marketing path="/career-benefits-of-temporary-work-blog" page="temporary-work" />
      <Marketing path="/white-paper-accelerate-student-achievement-by-20-higher-than-average-with-this-after-school-program" page="achievement" />
      <Marketing path="/privacy-policy-2" page="privacy" />
      <Marketing path="/terms-of-service" page="terms" />
      <Marketing path="/helpful-articles" page="helpful-articles" />
      <Marketing path="/helpful-articles/:slug" page="helpful-article" />
      <Marketing path="/privacy-policy" page="privacy" />
      <Marketing default page="not-found" />
    </Router>
  );
}

export default App;
